import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store'; // 引入 Vuex 以便路由守卫使用
import Home from '@/views/home/Home.vue';

Vue.use(Router);

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: { requiresAuth: false }
    },
    {
        path: '/about',
        name: 'About',
        component: () => import('@/views/about/About.vue'), // 官网关于页面
        meta: { requiresAuth: false }
    },
    {
        path: '/archive',
        name: 'Archive',
        component: () => import('@/views/archive/Archive.vue'), // 服务页面
        meta: { requiresAuth: false }
    },
    {
        path: '/classification',
        name: 'Classification',
        component: () => import('@/views/classification/Classification.vue'), // 分类
        meta: { requiresAuth: false }
    },
    {
        path: '/classifications',
        name: 'Classifications',
        component: () => import('@/views/classification/Classifcations.vue'), // 分类
        meta: { requiresAuth: false }
    },
    {
        path: '/tag',
        name: 'Tag',
        component: () => import('@/views/tag/Tag.vue'), // 联系我们页面
        meta: { requiresAuth: false }
    },
    {
        path: '/tags',
        name: 'Tags',
        component: () => import('@/views/tag/Tags.vue'), // 联系我们页面
        meta: { requiresAuth: false }
    },
    {
        path: '/article',
        name: 'Article',
        component: () => import('@/views/article/Article.vue'), // 联系我们页面
        meta: { requiresAuth: false }
    },
    //   {
    //     path: '/dashboard',
    //     name: 'Dashboard',
    //     component: () => import('@/views/Dashboard.vue'), // 需要登录的后台管理页面
    //     meta: { requiresAuth: true }
    //   },
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/login/Login.vue'),
        meta: { requiresAuth: false }
    },
    {
        path: '*',
        name: 'NotFound',
        component: () => import('@/views/NotFound.vue')
    }
];

const router = new Router({
    mode: 'history', // 使用 HTML5 History 模式
    base: process.env.BASE_URL,
    routes,
    scrollBehavior: () => ({ y: 0 }),
})

// 仅后台管理页面需要身份验证
router.beforeEach((to, from, next) => {
    if (to.meta.requiresAuth && !store.getters.isAuthenticated) {
        next({ name: 'Login' });
    } else {
        next()
    }
})

export default router;
